const APPCONFIG = {
    ENDPOINTS: {
        SECURITYURL: import.meta.env.VITE_SECURITYURL,
        PRODUCERURL: import.meta.env.VITE_PRODUCERURL,
    },
    FOOTER: {
        ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
        VERSION: 'V 3.3.1',
        PORTAL: 'Portal de Productores',
        BUTTON_TEXT: 'Soporte técnico',
    },
    URLS: {
        CANALESLINK: import.meta.env.VITE_CANALESLINK,
        EBROKERLINK: import.meta.env.VITE_EBROKERLINK,
    },
    ENABLESCHEDULER: import.meta.env.VITE_ENABLESCHEDULER
}
export { APPCONFIG };
